exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cancel-sub-modal p[data-v-7e92fa88] {\n  padding: 2em 0;\n}\n.cancel-sub-modal .modal-link-section[data-v-7e92fa88] {\n  cursor: pointer;\n  padding: 1.2em 1.5em;\n}\n.cancel-sub-modal .icon-caret-right[data-v-7e92fa88] {\n  color: #53284f;\n  position: absolute;\n  top: 50%;\n  margin-top: -0.75em;\n  right: 1.2em;\n}\n.cancel-sub-modal .support-ctas[data-v-7e92fa88] {\n  padding-bottom: 2em;\n}\n.cancel-sub-modal .submit-buttons[data-v-7e92fa88] {\n  padding-top: 3em;\n}\n", ""]);

// exports
